<!-- MENU -->
<app-menu [menu]="menu"></app-menu>
<!-- MENU -->

<div class="container-fluid">
    <div class="row">
        <div class="col-md-12 nopadding">
            <div class="header" style="background-image: url('./assets/img/sub_header_home.jpg');">
                <div class="row justify-content-center search">
                    <div class="col-8 align-self-center">
                        <h6>{{ 'home.hero' | t }}</h6>
                        <input class="custom-input" type="text" [placeholder]="'home.searchPlaceholder' | t">
                    </div>
                </div>
            </div>

            <div class="row justify-content-center steps ">
                <h2 class="main_title">{{ 'home.simple' | t }}</h2>
                <div class="card" style="width: 18rem;">
                    <img src="./assets/img/phone.png" class="card-img-top" [alt]="'home.scan' | t">
                    <div class="card-body">
                        <span>1</span>
                        <h5 class="card-title">{{ 'home.scan' | t }}</h5>
                        <p class="card-text">{{ 'home.scanDescription' | t }}</p>
                    </div>
                </div>
                <div class="card" style="width: 18rem;">
                    <img src="./assets/img/menu.png" class="card-img-top" [alt]="'home.review' | t">
                    <div class="card-body">
                        <span>2</span>
                        <h5 class="card-title">{{ 'home.review' | t }}</h5>
                        <p class="card-text">{{ 'home.reviewDescription' | t }}</p>
                    </div>
                </div>
                <div class="card" style="width: 18rem;">
                    <img src="./assets/img/comment.png" class="card-img-top" [alt]="'home.ready' | t">
                    <div class="card-body">
                        <span>3</span>
                        <h5 class="card-title">{{ 'home.ready' | t }}</h5>
                        <p class="card-text">{{ 'home.readyDescription' | t }}</p>
                    </div>
                </div>
            </div>

            <div class="row justify-content-center restaurants">

                <h2 class="main_title">{{ 'home.choose' | t }}</h2>
                <div class="card restaurant-card shadow-sm mb-4" *ngFor="let item of restaurants;"
                    (click)="goMenu(item)">

                    <img [src]="item.Logo" alt="{{item.Nombre}}" class="img-fluid restaurant-img">

                    <div class="card-body text-center">
                        <p class="card-title mb-0">{{ item.Nombre | titlecase }}</p>
                    </div>
                </div>

            </div>
        </div>
    </div>

</div>

<!-- MODAL DE PERFIL DE USUARIO -->
<app-login-register></app-login-register>

<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }"></ngx-loading>
